import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

export let portalRoot = document.createElement('portal');
document.body.appendChild(portalRoot);

function Portal({ children }) {
  let container = useRef(document.createElement('div'));
  portalRoot.appendChild(container.current);
  useEffect(
    () => () => {
      portalRoot.removeChild(container.current);
    },
    []
  );
  return createPortal(children, container.current);
}

Portal.propTypes = {
  children: PropTypes.element
};

export default Portal;
